import styled from 'styled-components';
import { Typography } from 'src/ui/common/atoms/typography';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { LazyLoadMedia } from 'src/ui/common/organisms/lazy-load-media';

export const StyledWrapper = styled(FlexBox)`
  background-color: ${({ theme }) => theme.colors.gs500};
  border-radius: 5px;
  padding: 10px 20px 10px 10px;
  height: 80px;
  width: 100%;
`;

export const StyledAvatarWrapper = styled.div`
  position: relative;
  margin-left: 20px;
`;

export const StyledCircle = styled.div`
  position: absolute;
  width: 25px;
  height: 25px;
  left: -20px;
  top: calc(50% - 25px/2);
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.gs400};
`;

export const StyledContentWrapper = styled.div`
  margin-left: 10px;
  width: 100%;
`;

export const StyledImage = styled(LazyLoadMedia)`
  border-radius: 40px;
`;

export const StyledCollectionName = styled(Typography)`
  margin-bottom: 5px;
  width: 162px;
  height: 15px;
  background-color: ${({ theme }) => theme.colors.gs400};
  border-radius: 2px;
`;

export const StyledCollectionVolume = styled.div`
  width: 74px;
  height: 10px;
  background-color: ${({ theme }) => theme.colors.gs400};
  border-radius: 2px;
`;
